// CRA only exposes env keys that start with REACT_APP_*
const RAW_ENV_BASE = (
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_BASE ||
  ""
).trim();

// Remove trailing slash if present
const CLEAN_ENV_BASE = RAW_ENV_BASE.replace(/\/+$/, "");

// Sensible fallbacks
const FALLBACK_PROD = "https://97atr26c9f.us-east-2.awsapprunner.com";
const FALLBACK_DEV = "http://localhost:4000";

// Final base URL
export const API_BASE =
  CLEAN_ENV_BASE ||
  (process.env.NODE_ENV === "production" ? FALLBACK_PROD : FALLBACK_DEV);

// --- tiny fetch wrapper with timeout + JSON handling ---
async function safeFetch(url, options = {}) {
  const { timeoutMs = 15000, ...rest } = options;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const res = await fetch(url, {
      // CORS-friendly defaults
      method: "GET",
      headers: { Accept: "application/json" },
      mode: "cors",
      // Add credentials: 'include' here only if you use cookies
      signal: controller.signal,
      ...rest,
    });

    // Throw on non-2xx
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`HTTP ${res.status} ${res.statusText}: ${text}`);
    }

    // Try JSON; fall back to text
    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) return res.json();
    return res.text();
  } finally {
    clearTimeout(id);
  }
}

// ---- Public API ----

export async function searchAgents(query, limit = 25) {
  const q = (query || "").trim();
  if (!q) return [];

  try {
    const url = `${API_BASE}/api/agents?query=${encodeURIComponent(
      q
    )}&limit=${encodeURIComponent(limit)}`;
    return await safeFetch(url);
  } catch (e) {
    // Show a single console warning, return empty so UI doesn't explode
    // eslint-disable-next-line no-console
    console.warn("searchAgents failed:", e);
    return [];
  }
}

export async function getAgent(slug) {
  const s = (slug || "").trim();
  if (!s) return null;

  try {
    const url = `${API_BASE}/api/agents/${encodeURIComponent(s)}`;
    return await safeFetch(url);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("getAgent failed:", e);
    return null;
  }
}

// Optional helper while debugging
export function health() {
  return safeFetch(`${API_BASE}/health`).catch((e) => {
    // eslint-disable-next-line no-console
    console.warn("health check failed:", e);
    return null;
  });
}
